import Injector from 'vue-inject';

export const MODE_SUBSCRIPTION = 'subscription';
export const MODE_ONEOFF = 'oneoff';
export const MODE_MULTI_MONTH = 'multi_month';

export default class ModeService {
  constructor(cs) {
    this.clusterService = cs;
  }

  getDefault(campaign) {
    return this.clusterService.getClusters()
      .then(() => {
        const clusters = this.clusterService.availableClusters(campaign)
          .filter(c => c.minReach <= campaign.potentialReach / c.reachDivider);
        // Draft default mode should be set to subscription/multimonth (#29024)
        const subscription = clusters.find(cluster => cluster.fullModeName === MODE_SUBSCRIPTION);
        const multiMonth = clusters
          .filter(cluster => cluster.fullModeName.includes(MODE_MULTI_MONTH))
          .sort(
            (a, b) => parseFloat(b.subscription_duration) - parseFloat(a.subscription_duration),
          );

        if (subscription) {
          return subscription.fullModeName;
        } else if (multiMonth[0]) {
          return multiMonth[0].fullModeName;
        } else if (clusters.length) {
          return clusters[0].fullModeName;
        }

        throw new Error('no modes');
      });
  }
}

Injector.service('modeService', ['clusterService'], ModeService);



// WEBPACK FOOTER //
// ./src/services/ModeService.js